export type MachineListSortDirection = 'asc' | 'desc' | '';

export interface MachineListCategoryState {
  sortColumn: string;
  sortDirection: MachineListSortDirection;
  searchText: string;
  currentPage: number;
  itemsPerPage: number;
  visibleColumns: string[];
}

export interface MachineListCategoryPreferences {
  itemsPerPage: number;
  visibleColumns: string[];
}

export interface MachineListViewUserConfig {
  activeCategory: string;
  categories: Record<string, MachineListCategoryPreferences>;
}

export const MACHINE_LIST_VIEW_USER_CONFIG_KEY = 'machineListViewUserConfig';
export const MACHINE_LIST_ITEMS_PER_PAGE_OPTIONS = [10, 25];

export const DEFAULT_CATEGORY_STATE: MachineListCategoryState = {
  sortColumn: 'machineName',
  sortDirection: '',
  searchText: '',
  currentPage: 1,
  itemsPerPage: 10,
  visibleColumns: [],
};

export function createDefaultUserConfig(): MachineListViewUserConfig {
  return {
    activeCategory: '',
    categories: {},
  };
}
